export enum HelpText {
  menuOrder = 'admin.store.statistics.orders',
  menuCatalog = 'admin.store.settings.catalog.title',
  menuLocation = 'admin.store.locations.text',
  menuSettings = 'admin.store.settings.title',
  menuStatistics = 'admin.store.statistics.title',
  menuUser = 'admin.store.users.header',
  menuSubscription = 'admin.store.setting.billing',
  menuCustomers = 'admin.store.customers.customers',
  menuBilling = 'admin.store.setting.billing',
  menuPartner = 'admin.global.partnerProgram.label',
  menuRegisterStore = 'admin.register.registerTitle',
  menuSharePreview = 'admin.store.share.sharePreview',
  menuCatalogOffer = 'admin.store.catalogOffer',
  menuCatalogCombo = 'admin.store.catalog.catalogCombo',
  menuManageByExcel = 'admin.store.catalogManageByExcel',
  tableManageByExcel = 'admin.store.tableHelpText',
  menuCatalogOptionsByExcel = 'admin.store.menuCatalogOptionsByExcel',
  menucatalogChangeAndTranslateLable = 'admin.store.catalog.importTranslation',
  menucatalogImportFromPhoto = 'admin.store.catalog.importImage',
  menuCatalogCategory = 'admin.store.catalogCategory',
  menuCatalogPriceVariants = 'admin.store.catalog.priceVariants',
  menuCatalogOptionGroup = 'admin.store.catalog.catalogOptionGroup',
  menuCatalogItemGroup = 'admin.store.catalog.catalogItemGroup',
  menuSettingsStoreDetails = 'admin.store.settings.details.title',
  menuSettingsStoreOrdering = 'admin.store.statistics.orderCapture',
  menuSettingsMultipleStore = 'admin.store.setting.multiStore.title',
  menuSettingsStorePayment = 'admin.store.settings.paymentProviders.title',
  menuSettingsStorePickup = 'admin.store.orderDeliveryMethod.pickup',
  menuSettingsStoreDelivery = 'admin.store.settings.delivery.title',
  menuSettingsStoreLocations = 'admin.store.settings.tableOrdering.title',
  menuSettingsStoreCatalog = 'admin.store.settings.catalog.title',
  menuSettingsStoreOrderingRule = 'admin.store.setting.orderingRules.title',
  menuSettingsStoreSchedules = 'admin.store.settings.schedules.title',
  menuSettingsStoreMarketing = 'admin.store.settings.marketing.title',
  menuSettingsStorePromotions = 'admin.store.settings.promotions.title',
  menuSettingsStoreDiscountVouchers = 'admin.store.settings.discountVouchers.title',
  menuSettingsStoreOnlinePresence = 'admin.store.marketing.onlinePresence.title',
  menuSettingsStoreTracking = 'admin.store.marketing.tracking.title',
  menuSettingsStoreDomainsAndApps = 'admin.store.setting.domainsApps.title',
  menuSettingsStoreIntegrations = 'admin.store.setting.integrations.title',
  menuSettingsStoreBranding = 'admin.store.settings.branding.title',
  menuSettingsStoreLoyalty = 'admin.store.settings.loyalty.title',
  menuSettingsStoreOrderManagement = 'admin.store.settings.orderManagement.title',
  menuReservations = 'admin.store.statistics.reservations',
  menuRefundBalance = 'admin.store.statistics.balanceRefunds',
  menuSettingsReservations = 'admin.store.statistics.reservations',
  menuEvents = 'admin.store.events.event',
  menuCatalogGiftCard = 'admin.store.settings.giftCards.title',
  menuBookingTier = '',
  enableCustomerAuthentication = '',
  displayPickupAddress = '',
  delieveryZoneRestriction = '',
  openTabOrdering = '',
  requestOrderDateUpfront = '',
  maximumItemsPerSlot = '',
  requestDesiredTime = '',
  DesiredTimeInMinutes = '',
  SlotDurationInMinutes = '',
  defaultOrderingMode = '',
  apps = '',
  mynext = '',
  hubrise = '',
  powersoft = '',
  gladius = '',
  eposDirect = '',
  poster = '',
  eposNow = '',
  jcc = '',
  stripe = '',
  rms = '',
  trust = '',
  paymentsense = '',
  payabl = '',
  vivawallet = '',
  square = '',
  paypal = '',
  other = '',
  globalpay = '',
  nbgpay = '',
  cardlink = '',
  eurobank = '',
  alphabank = '',
  mollie = '',
  mypos = '',
  fygaro = '',
  apcopay = '',
  epay = '',
  hobex = '',
  flitt = '',
  ryft = '',
  abapayway = '',
  rootline = '',
  solidgate = '',
  clearaccept = '',
  emerchantpay = '',
  neosoft = '',
  citypay = '',
  countAgainstSlotCount = '',
  optiongroup = '',
  allowordering = '',
  wooDelivery = '',
  paymentOptions = '',
  standalonePayments = '',
  openTableOnAdminOrder = '',
  manageStock = '',
  addOptionGroup = '',
  facebookPixel = '',
  googleAnalytics = '',
  flexDelivery = '',
  shopify = '',
  customIntegration = '',
  inheritParentStoreCatalog = '',
  inheritCatalog = '',
  inheritSchedules = '',
  menuStandalonePayment = 'admin.store.statistics.standalonePayment',
  paymentRequests = '',
  sunSoft = '',
  twinSoft = '',
  hit = '',
  googleTagManager = '',
  wolt = '',
  orderFulfilment = '',
  MemberAuthentication = '',
  ClearBasketInactivity = '',
  TermsConditionsAcceptance = '',
  EnableBillingAddress = '',
  BuzzerNumber = '',
  TimeRangeMinutes = '',
  AllowOrderStore = '',
  AllowOrderDeletion = '',
  DetailedOrderReceipt = '',
  AutomaticallyAcceptOrders = '',
  PayLaterOption = '',
  AdminPaymentOption = '',
  DefaultAdminPaymentOption = '',
  AllowCustomerReservations = '',
  DefaultReservationDduration = '',
  ReservationSchedule = '',
  CustomerReservationSchedule = '',
  DesiredTimeIntervals = '',
  ServiceCharge = '',
  LocationType = '',
  DefaultCatalogView = '',
  SameDayOrdering = '',
  OrdersPerSlot = '',
  DisplayDesiredDate = '',
  DesiredDateTime = '',
  Domains = '',
  NewUserDiscount = '',
  iotsoftIntegration = '',
  witecIntegration = '',
  wposIntegration = '',
  wrapp = '',
  purplei = '',
  tissl = '',
  loyverse = '',
  meganetIntegration = '',
  vrpayment = '',
  dnapayments = '',
  wallee = '',
  pxp = '',
  menuProductImportByExcel = 'admin.store.products.importProducts',
  menuProductUpdateByExcel = 'admin.store.products.updateProducts',
  'linked-categories' = 'admin.store.catalog.linkExternalCategories',
  menuPaymentTransactions = 'admin.store.paymentTransactions.title',
  menuVoucherTopups = 'admin.store.voucherTopups.title',
  menuVoucherTopup = 'admin.store.marketing.tabs.topup',
  menuCheckoutRecommendations = 'admin.store.checkoutRecommendations.title',
  menuSettingsStoreNotifications = 'admin.store.settings.notifications.title',
}
